var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{attrs:{"title":"Backhaul","icon":"fa fa-wifi","table-ref":"backhaultable","url":'/backhaul/site/' + _vm.rowData.id,"hide-org-badge":"","show-search":false,"fields":_vm.backhaulFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }